import React from 'react';
import { Grid, Input, Button, Form, TextArea, Dropdown } from 'semantic-ui-react';
import Server from '../../functions/server'
import $ from "jquery";


class Add extends React.Component {

state = {
  setPartNo: [],
  value: '',
  brandOption: [],
}

componentDidMount() {
  this.getPartNo();
  this.getBrandId();
}

getPartNo() {
  let context = this;
  let data1 = { 'branch': this.props.branchName };
  $.ajax({
    type: 'POST',
    data: data1,
    url: Server() + 'spares/getpartandsparename.php',
    success: function(data)
    {
      try {
        data = JSON.parse(data);
        context.setPartno(data);
        context.setState({
          load: false,
        });
      } catch (e) {
        context.setState({
          load: false,
        });
      }
    },
    error: function(e)
    {
      alert('Try again!!')
      context.setState({
        load: false
      });
    }
  });
}

getBrandId() {
  let context = this;
  context.setState({
    load: true,
    message: 'Getting Brands!!!'
  });
  let data1 = {};
  $.ajax({
    type: 'POST',
    data: data1,
    url: Server() + 'addmenu/branddetails/getallbrands.php',
    success: function(data)
    {
      context.setState({ load: false })
      try {
        data = JSON.parse(data);
        context.setBrand(data);
      } catch (e) {
        console.log(e);
      }
    },
    error: function(err)
    {
      context.setState({
        load: false,
      });
      alert('Try again!!!!')
    }
  });
}

setBrand(data) {
  let context = this;
  var x = [];
  data.map((y) => {
    let name = y.id + ' -> ' + y.brand_name;
    x.push({key: name, text: name, value: y.id});
  });
  try {
    context.props.getBrands(x);
    context.setState({
      brandOption: x,
    });
  } catch (e) {

  }
}

brand = (f, { value }) => {
  this.setState({
    value: value
  });
}


setPartno(data) {
  let context = this;
  var executive = [];
  data.map((y) => {
    executive.push({key: y.partno+"->"+y.spare_name, text: y.partno+"->"+y.spare_name, value: y.partno});
  });
  this.setState({
    setPartNo: executive
  })
}

cancel() {
  this.props.handleClose();
}

onChange = (type) => (e, {value}) => {
  this.setState({
    [type]: value,
    error: ''
  })
}

update() {
  let context = this;
  let partno= this.state.selectedspare;
  let min_stock = this.state.min_stock;
  let rack_no = this.state.rack_no;
  let brand_id = this.state.value;

  if (partno == '' || partno == null || partno == undefined) {
    this.setState({
      error: 'Enter the Part No'
    });
    return;
  }

  if (brand_id == '' || brand_id == null || brand_id == undefined) {
    this.setState({
      error: 'Enter the Brand Id'
    });
    return;
  }

  if (min_stock == '' || min_stock == null || min_stock == undefined) {
    this.setState({
      error: 'Enter the Minmum Stock'
    })
    return;
  }

  if (rack_no == '' || rack_no == null || rack_no == undefined) {
    this.setState({
      error: 'Enter the Rack Number'
    })
    return;
  }


  let data1 = { 'rack_no': rack_no, 'min_stock': min_stock, 'partno': partno,
                'branch' : this.props.branchName, 'brand_id': brand_id};

  $.ajax({
    type: 'POST',
    data: data1,
    url: Server() + 'branchdetails/addspares.php',
    success: function(data)
    {
      context.setState({
        load: false,
      });
      if (data == 1) {
        context.props.updateDatas1();
      }
    },
    error: function(e)
    {
      alert('Try again!!')
      context.setState({
        load: false
      });
    }
  });
}


partno = event => {
  let value = event.target.value;
  value = value.split('->')[0];
  this.setState({ selectedspare: value })
}

render() {
  return (
    <div>
      <Grid>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          Part no<br/>
          <datalist id="suggestions">
              {this.state.setPartNo.map((x) => {
                return (
                  <option id='box'>{x.text}</option>
                )
              })}
          </datalist>
          <input style={{height: 35, width: '100%'}} onChange={this.partno} autoComplete="on"
          list="suggestions" value={this.state.selectedspare}/>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          Brand<br/>
          <Dropdown placeholder='Brand' style={{ borderColor: '#5A9CBB' }}
          fluid search selection onChange={this.brand}
           options={this.state.brandOption} value={this.state.value} />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          Min Stock<br/>
          <Input fluid focus
            onChange={this.onChange('min_stock')}
            placeholder='Min Stock' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          Rack No<br/>
          <Input fluid focus
            onChange={this.onChange('rack_no')}
            placeholder='Rack No' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <center><div style={{color: 'red'}}>{this.state.error}</div></center>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          <Button fluid onClick={this.cancel.bind(this)}>Cancel</Button>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          <Button fluid onClick={this.update.bind(this)}>Save</Button>
        </Grid.Column>
      </Grid>
    </div>
  );
}
}

export default Add;
